import React, { useEffect, useState } from 'react';
import {
	BringzzPageContainer,
	BringzzIcon,
	BringzzText,
	BringzzTabs,
	BringzzTab,
	BringzzTabPanel,
	BringzzImage,
	BringzzGallery,
} from '@bringzz/components';
import { useNavigation } from 'context/NavigationContext';
import { useLocation } from 'react-router-dom';
import useRequest from 'hooks/useRequest';
import { useAuth } from 'context/AuthContext';
import { parse } from 'date-fns';
import { useTranslation } from 'react-i18next';

const Posts = () => {
	const { t } = useTranslation('posts');
	const { navigate, backPress } = useNavigation();
	const { sendRequest, loading } = useRequest();
	const [posts, setPosts] = useState([])
	const { user } = useAuth();

	const fetchPosts = async () => {
		await sendRequest({
			method: 'POST',
			url: `/module/post/getPosts`,
			data: { userId: user.id }
		}).then((response) => {
			if (response.status === 'success') {
				console.log(response.data);
				setPosts(response.data)
			}
		}).catch((error) => {
			console.error(error);
		})
	}

	useEffect(() => {
		fetchPosts()
	}, [])

	const ispublished = (post) => {

		if(!post.release){
			return false;
		}

		const releaseDate = parse(post.release, window.datetimeFormat, new Date())
		if(releaseDate > new Date()){ // release in future
			return false
		}

		if(post.validUntil){
			const expiry = parse(post.validUntil, window.datetimeFormat, new Date())
			if(expiry < new Date()){ // after expire date
				return false
			}
		}
		return true; // after release Date and no expiry or before it
	}

	return (
		<BringzzPageContainer
			header={{
				left: (
					<BringzzIcon
						size='22'
						icon='IconChevronLeft'
						folder='LineIcons'
						className='cursor-pointer'
						onClick={backPress}
					/>
				),
				// right: (
				// 	<div className='flex flex-row space-x-4'>
				// 		<BringzzIcon
				// 			size='22'
				// 			icon='IconUpload'
				// 			folder='LineIcons'
				// 			className='cursor-pointer'
				// 		/>
				// 		<BringzzIcon
				// 			size='22'
				// 			icon='IconMore'
				// 			folder='LineIcons'
				// 			className='rotate-90 cursor-pointer'
				// 		/>
				// 	</div>
				// ),
				title: <BringzzText tag='h2'>{t('main.title')}</BringzzText>
			}}
		>
			<div className='p-4 space-y-4'>
				<BringzzTabs defaultActiveTab='tab1'>
					<BringzzTab id='tab1'>
						<BringzzText tag='h4' className='font-bold'>
							{t('main.tabs.published')}
						</BringzzText>
					</BringzzTab>
					<BringzzTabPanel id='tab1'>
						{posts.filter(post => ispublished(post)).length === 0 ? (
							<div className="flex flex-col items-center justify-center p-8 text-center">
								<BringzzIcon
									size="48"
									icon="IconImage"
									folder="LineIcons"
									className="text-gray-400 mb-4"
								/>
								<BringzzText tag="h3" className="text-gray-600 mb-2">{t('main.empty.published.title')}</BringzzText>
								<BringzzText className="text-gray-500">{t('main.empty.published.subtitle')}</BringzzText>
							</div>
						) : (
							<BringzzGallery>
								{posts.map(post => ispublished(post) ? post : false).filter(Boolean).map((post, index) => (
									<div className='cursor-pointer' onClick={() => navigate(`/settings/posts/detail?id=${post.id}`)} key={index} >
										<BringzzImage className='h-32 w-full' src={post.images[0].content} alt='' />
									</div>
								))}
							</BringzzGallery>
						)}
					</BringzzTabPanel>
					<BringzzTab id='tab2'>
						<BringzzText tag='h4' className='font-bold'>
							{t('main.tabs.unpublished')}
						</BringzzText>
					</BringzzTab>
					<BringzzTabPanel id='tab2'>
						{posts.filter(post => !ispublished(post)).length === 0 ? (
							<div className="flex flex-col items-center justify-center p-8 text-center">
								<BringzzIcon
									size="48"
									icon="IconDraft"
									folder="LineIcons"
									className="text-gray-400 mb-4"
								/>
								<BringzzText tag="h3" className="text-gray-600 mb-2">{t('main.empty.unpublished.title')}</BringzzText>
								<BringzzText className="text-gray-500">{t('main.empty.unpublished.subtitle')}</BringzzText>
							</div>
						) : (
							<BringzzGallery>
								{posts.map(post => !ispublished(post)? post : false).filter(Boolean).map((post, index) => (
									<div className='cursor-pointer' onClick={() => navigate(`/settings/posts/detail?id=${post.id}`)} key={index}>
										<div className='relative'>
											<BringzzImage className='h-32 w-full' src={post.images[0].content} alt='' />
											{!post.published && post.release &&
												<div className='absolute bottom-0 right-0 text-white p-2'>
													<BringzzIcon
														folder='LineIcons'
														icon='IconClockAlt1'
														size='24'
														className='text-white'
													></BringzzIcon>
												</div>}
										</div>
									</div>
								))}
							</BringzzGallery>
						)}
					</BringzzTabPanel>
				</BringzzTabs>
			</div>
		</BringzzPageContainer>
	)
};

export default Posts;
